import DocusaurusFooter from '../DocusaurusFooter'
import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'
import { bugHuntingHeatmap } from '../../docs-routes'

const BugHuntingHeatmap = () =>
  <>
    <Paragraph>
      <Color variant='theme-description-text'>
        The Bug Hunting heatmap visualizes the failure rate of actions within a model. Any action with more failures than passes has a colored background.
      </Color>
    </Paragraph>
    <DocusaurusFooter path={bugHuntingHeatmap} />
  </>

export default BugHuntingHeatmap
